<template>
  <transition name="slide-down">
    <div class="modal" tabindex="-1" role="dialog" :class="{show: isShowModal}">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">{{ title }}</h6>
            <button type="button" class="close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="confirmAction">
              {{ saveLabel }}
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal">
              {{ closeLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ErrorModal',
  props: {
    title: {
      type: String,
      default: null,
      description: 'Title Modal'
    },
    closeLabel: {
      type: String,
      default: "Close"
    },
    saveLabel: {
      type: String,
      default: "OK"
    },
  },
  data() {
    return {
      isShowModal: false
    };
  },
  methods: {
    closeModal() {
      this.isShowModal = false;
      document.querySelector('body').style.cssText = 'height: unset; overflow-y: unset';
    },
    openModal() {
      this.isShowModal = true;
      document.querySelector('body').style.cssText = 'height: 100vh; overflow-y: hidden';
    },
    confirmAction() {
      this.$emit('confirm');
      this.closeModal();
    }
  }
});
</script>

<style lang="scss" scoped>
  .modal {
    background-color: rgb(204 204 204 / 58%);
    .modal-dialog {
      width: 370px;
    }
    .modal-title {
      font-size: 14px;
      line-height: 32px;
    }
    &.show {
      display: block!important;
    }
    .modal-footer {
      display: flex;
      justify-content: center;
      button {
        flex: 1;
        height: 35px;
        line-height: 35px;
        padding: 0;
      }
    }
  }
</style>
